import { render, staticRenderFns } from "./ForgotPasswordPhone.vue?vue&type=template&id=1d664ea4&scoped=true&"
import script from "./ForgotPasswordPhone.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordPhone.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordPhone.vue?vue&type=style&index=0&id=1d664ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d664ea4",
  null
  
)

export default component.exports